import { render } from "./OmniViewer.vue?vue&type=template&id=40364c8c"
import script from "./OmniViewer.vue?vue&type=script&lang=js"
export * from "./OmniViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__